import React, { Component } from "react";

class Aboutcard extends Component {
  state = {
    latestposttitle: "searching...",
    firstpostcontent: "looking up..."
  };
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <div className="home-card">
        <section id="team" className="basicAbout">
          <h5>About</h5>
          <p>
            The <a href="http://djmcloud.com">djmcloud</a> podcast has run on and off since 2010.  Its sister podcast, the <a href="http://pacificipelican.us/podcast">pacificipelican.us/podcast</a> video series, ran from 2007 to 2011.
          </p>
          <p>
            Over its life the podcast has covered technology, news, sports, and culture from the perspective of its hosts.  Audio clips and sound effects have often played roles in the production, as we play bits of songs we like along with news clips, <a href="http://danieljmckeown.com/soundboard/">soundboard</a> drops, and found audio--or even the audio track of a video that we attempt to narrate.
          </p>
          <p>
            The podcast feed can be found at <a href="http://feeds2.pacificpelican.us/djmblog" className="haeck rss">this RSS feed</a> and you can also <a href="https://itunes.apple.com/us/podcast/podcast-djmcloud-64/id415807688?mt=2" className="haeck itunes">subscribe via iTunes</a>.
          </p>
          <p>
            Back in the mid-2010s the podcast was partly a platform for talking about the strange occurrences going on out on the Internet: thus for a while one of the podcast's appellations was "The Internet Garbage Collector."  We talked about <a href="http://djmcloud.danieljmckeown.com/64/2014/08/29/pacificpelican-us64-podcast-136-a-shirt-with-two-wolves-and-a-moon-on-it/">fedoras</a>, <a href="http://djmcloud.danieljmckeown.com/64/2014/02/24/pacificpelican-us64-podcast-124-like-a-team-of-horses/">epic sax</a>, <a href="http://djmcloud.danieljmckeown.com/64/2014/09/08/pacificpelican-us64-podcast-137-there-is-no-star/">toilets abandoned roadside</a>, <a href="http://djmcloud.danieljmckeown.com/64/2014/03/31/pacificpelican-us64-podcast-128-you-dont-have-to-have-a-long-beard-to-download-it/">the plague of open offices</a>, <a href="http://djmcloud.danieljmckeown.com/blog/2012/10/podcast-51-dont-play-if-youre-hung-over/">Cleveland</a>, the <a href="http://djmcloud.danieljmckeown.com/64/2013/12/11/pacificpelican-us64-podcast-118-jump-over-rocks-and-dodge-penguins/">grape lady</a>, <a href="http://djmcloud.danieljmckeown.com/blog/2013/05/podcast-89-i-like-to-just-go-with-what-i-see/">social network data loss</a>, <a href="http://djmcloud.danieljmckeown.com/blog/2013/04/podcast-84-austerity-mongers/">economic mismanagement abbetted by Excel mistakes</a>, and <a href="http://djmcloud.danieljmckeown.com/64/2018/04/19/how-many-mattresses-podcast-156/">junk warehouses</a> among many other topics.
          </p>
          <p>

          </p>
          <p>
            For a reverse-chronological list of recent episodes with show notes and links, check <a href="http://djmcloud.danieljmckeown.com/64">djmcloud.danieljmckeown.com/64</a>.
          </p>
          <ul id="home">
          </ul>
        </section>
      </div>
    );
  }
}

export default Aboutcard;



// WEBPACK FOOTER //
// ./src/aboutcard.js